
<template>
    <NuxtLayout name="casino"
        key="hilo"
        class='hilo-game-body'
        :style="{
            '--hilo-yellow': '#fed700',
            '--hilo-blue': '#fed700',
        }"
    >
        <GameSettingsDiceTabsWrapper
            class='setting-bar'
        >
            <ClientOnly>
                <GameSettingsButtonLiveChat v-if="useUserStore().isLoggedIn" v-model="isOpenLiveChat" />
            </ClientOnly>
            <GameSettingsButtonAnimate v-model="settingStore.animation" />
            <GameSettingsButtonFairness v-model="isOpenFairness" />
            <GameSettingsButtonRule v-model="isOpenRule" name="hilo" />
            <GameSettingsButtonVocie
                v-model="settingStore.inhouseGames.sound.on"
                v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                saveAfterChange
            />
        </GameSettingsDiceTabsWrapper>
        <!-- 
            ↑ 顶部的通用按钮
            ↓ 游戏区
        -->
        <!-- 👇游戏结果显示框（提现时弹出，默认不可见） -->
        <section
            class="result-popup" 
            v-show="isShowResultPopup"
        >
            <div class="popup-box">
                <ClientOnly>
                    <em>
                        {{ getFixed(oGameInfo.multi) }}x
                    </em>
                    <small>
                        <CurrentCoin class="coin"/>
                        {{ getFixed(oGameInfo.winAmount) }}
                    </small>
                </ClientOnly>
            </div>
        </section>
        <section class="game-stage">
            <ClientOnly>
                <div class="hilo__left">
                    <IconSvgUse class="jackpot-mark mark-01"
                        width="16" height="16"
                        use="icon-question"
                        @click="()=>jackpotControler(true)"
                    />
                    <img class="jackpot-img" src="@/assets/imgs/jackpot/jackpot-title.webp" />
                    <div class="number-group" >
                        <span class="number-a" >
                            <b>
                                {{
                                    padEndByZero(
                                        handleExchangeRate(globalStore?.jackpotSum['hilo'])?.toFixed?.(0)
                                    )
                                }}
                            </b>
                            <em class='currency'>
                                {{ currentCurrency.toLocaleUpperCase() }}
                            </em>
                        </span>
                        <span class="number-b">
                            <em class="card-7" 
                                v-for="cur of 4" 
                                :key="cur" 
                                :class="{
                                    'active-jackpot': cur <= oJoinStateStore.jackpotDelay,
                                }"
                            >
                                7
                            </em>
                        </span>
                        <IconSvgUse class="jackpot-mark mark-02"
                            width="16" height="16"
                            use="icon-question"
                            @click="()=>jackpotControler(true)"
                        />
                    </div>
                </div>
                <!-- 左-中分界 -->
                <div class="hilo__center">
                    <div class="deck">
                        <div class="card-wrap">
                            <Poker big :failed="oGameInfo.status === 'lose'" />
                            <Poker big 
                                v-for="(cur, idx) of round.slice(-2)"
                                :key="`${idx}/${round.length}-${cur.key}`"
                                :iCardNo="cur.card"
                                class="float"
                                :class="{
                                    [[round.length, idx].includes(1) ? 'coming' : 'leaving']: !cur.fromLastRound,
                                }"
                            />
                        </div>
                        <!-- 👆 卡片 -->
                        <!-- 👇 按钮 -->
                        <button class="skip-btn" 
                            @click="toSkip"
                            v-click-and-rest
                            :disabled="['cashout', 'lose'].includes(oGameInfo.status)"
                        >
                            <svg viewBox="0 0 117 36" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.43 7.48A10 10 0 0115.11 0h86.78a10 10 0 019.68 7.48l4.17 16A10 10 0 01106.06 36H10.94a10 10 0 01-9.68-12.52l4.17-16z"></path>
                            </svg>
                            <span class='text' >
                                <IconSvgUse use="circle-narrow" size="13px" />
                                {{ $t('hilo.skip') }}
                                ({{ this.iMaxSkip - this.iSkiped }})
                            </span>
                        </button>
                    </div>
                    <!-- ↓移动端可见押注按钮  -->
                    <div class="buttons-aside">
                        <btnForChosing
                            type="b"
                            direction="up"
                            :disabled="isClicking"
                            @click="()=> toChose('high')"
                        ></btnForChosing>
                        <btnForChosing
                            type="b"
                            direction="down"
                            :disabled="isClicking"
                            @click="()=> toChose('low')"
                        ></btnForChosing>
                    </div>
                </div>
                <!-- 中-右分界 -->
                <div class="hilo__right"
                    :class="{ [sStatus]: true }"
                >
                    <!-- <template v-if="isStatusPlay">
                        <span class="title" >
                            {{ $t('hilo.Coefficient') }}:
                        </span>
                        <em class="coefficient" >
                            {{ oGameInfo.multi.toFixed(4)*1 }}x
                        </em>
                    </template> -->
                    <figure class='figure'>
                        <img src="./img/most-low.svg" />
                        <figcaption v-html="$t('hilo.theLowest').replace('●', '<br/>')" >
                        </figcaption>
                    </figure>
                    <figure class='figure'>
                        <img src="./img/most-high.svg" />
                        <figcaption v-html="$t('hilo.theHighest').replace('●', '<br/>')" >
                        </figcaption>
                    </figure>
                </div>
            </ClientOnly>
        </section>
        <!-- 👆 游戏舞台区 -->
        <!-- 👇 游戏结果 -->
        <div class="result-bar flex justify-between"
            :style="{opacity: globalStore.client ? ~~!!(iTimesGamed > 0 || round[0]) : 0}"
        >
            <!-- ↓ 使用 clientOnly 防止 hydration 报错 -->
            <ClientOnly>
                <span class="left-word flex flex-col justify-center mr-5">
                    <small>
                        {{ $t('hilo.Coefficient') }}:
                    </small>
                    <em>
                        {{ getFixed(oGameInfo.multi || 0) }}x
                    </em>
                </span>
                <cardList
                    class="card-list flex-1"
                    :aRoundList="round"
                    :oGameInfo="oGameInfo"
                ></cardList>
            </ClientOnly>
        </div>
        <!-- 👇 操作区 -->
        <section class="control-area">
            <ClientOnly>
                <div class='column left'>
                    <CasinoBetOptionSectionAmountOption
                        class="input"
                        :isSubmiting="isStatusPlay"
                        :bet-amount-modal-value="oForm.amount"
                        :style="{height: '74px'}"
                        @update:bet-amount-modal-value="betAmountChanged"
                    />
                        <button
                            class="big-btn bet-btn"
                            @click="betBtnClick"
                            :disabled="isStatusPlay && !iRoundNoSkip"
                            :style="{padding: 0}"
                        >
                            <span class="text-[14px]">
                                {{
                                    isStatusPlay
                                    ? $t('game.cashout').toUpperCase()
                                    : $t('game.bet')
                                }}
                            </span>
                            <small v-if="isStatusPlay">
                                {{ getFixed(oForm.amount * oGameInfo.multi) }}
                            </small>
                        </button>
                </div>
                <!-- 左右分界 -->
                <div class='column right' >
                    <btnForChosing 
                        direction="up"
                        :disabled="isClicking"
                        @click="()=> toChose('high')"
                    ></btnForChosing>
                    <btnForChosing 
                        direction="down"
                        :disabled="isClicking"
                        @click="()=> toChose('low')"
                    ></btnForChosing>
                </div>
            </ClientOnly>
        </section>
        <!-- ▲ 游戏表单按钮 -->
    </NuxtLayout>
    <!-- 👇弹出窗口 -->
    <ModalJackpot
        :visible="jackpotVisible"
        game="Hilo"
        :update="() => jackpotVisible = false"
    />
    <ModalWinJackpotHandler
        :gameName="'hilo'"
        ref="jackpotHandler"
    />
</template>

<script>
import cardChaning from '@/assets/mp3/hilo/card-changing.mp3';
import guessedCorrect from '@/assets/mp3/hilo/guessed-correct.mp3';
import bettingLose from '@/assets/mp3/hilo/stop-betting-lose.mp3';
import bettingWin from '@/assets/mp3/hilo/stop-betting-win.mp3';
import placeBet from '@/assets/mp3/hilo/place-bet.mp3';
import HiloGBM from '@/assets/mp3/game_general_bgm.mp3';
// ------ ▲音乐 --------------------------------------------------------
import Poker from './_components/poker.vue';
import btnForChosing from './_components/btn-for-chosing.vue';
import cardList from './_components/card-list.vue';
// ------ ▲ .vue 组件 --------------------------------------------------------
import {methods, oCommunicationFn} from './js/hiloGame.js';
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import {useJoinStateStore} from '~/stores/cansino/joinState';
import {aPokerList, aPokerIntList} from './js/hiloConstant.js';
import useGlobalStore from '@/stores/global';

// 音乐列表
const oMusicLib = {
    bg: {
        src: HiloGBM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    placeBet:{ src: placeBet, },
    bettingWin:{ src: bettingWin, },
    cardChaning:{ src: cardChaning, },
    guessedCorrect:{ src: guessedCorrect, },
    bettingLose:{ src: bettingLose, },
};

export default defineComponent({
    name: 'hiloGame',
    components:{
        Poker,
        btnForChosing,
        cardList,
    },
    provide(){
        return {
            hilo: this, // 如果 hilo: 'string' 则 string 不是响应式的
            fnUpdateFairness: () => void 0, // 预置空方法，防止子组件报错
        };
    },
    data() {
        const oSettingBar = {
            isOpenLiveChat: false,
            isOpenRule: false,
            isOpenFairness: false,
        };
        const jackpotPercentData = [{"percent":"5%","bet_amount_pre":"0.00005","bet_amount_suf":"000","bet_currency":"BTC"},{"percent":"20%","bet_amount_pre":"0.0001","bet_amount_suf":"0000","bet_currency":"BTC"},{"percent":"50%","bet_amount_pre":"0.005","bet_amount_suf":"00000","bet_currency":"BTC"}];

        return {
            aPokerList, // 0为空，1-52有效
            aPokerIntList, // 同上
            iCardsQuantity: 13 * 4, // 13张 * 4个花色 = 52张 
            iCardNo: 0, // 有效范围：1 - 52 
            isShowResultPopup: false,
            isClicking: false,
            oMusic: {}, // 控制音乐
            settingStore: useSettingsStore(),
            jackpotPercentData,
            globalStore: useGlobalStore(),
            ...oSettingBar,
            oForm: {
                amount: 0,
            },
            round: [], // 游戏下方的记录
            oJoinStateStore: import.meta.client && useJoinStateStore(),
            oGameInfo: {},
            iMaxSkip: 20, // 最大跳过次数
            sHashLoaded: '',
            jackpotVisible: false,
            iTimesGamed: 0,
        };
    },
    computed: {
        sStatus(){
            if (this.isStatusPlay) return 'playing';
            return 'not-join';
        },
        sCardNo(){
            return this.aPokerList[this.iCardNo] || '';
        },
        isStatusPlay(){
            const aa = this.round.length > 0;
            // status: play, lose, cashout
            const bb = this.oGameInfo.status === 'play';
            return aa && bb;
        },
        iSkiped(){
            const arr = this.round.filter(cur=>{
                return cur.ac === 3;
            });
            return arr.length;
        },
        // ↓ 倒序（为了使页面上插入元素后也能在下方结果区的视觉上显示最新的一张牌
        aRoundReversed(){
            const arr = this.round.filter(cur=>{
                return !!cur.hash; // 没有 hash 的是用户押注前创建的
            }).map(cur => {
                return deepCopy(cur); // deepCopy 其成员，而不是其本身，以保留响应式
            });
            if (arr.at(-1) && this.oGameInfo.status === 'lose'){
                arr.at(-1).hasLost_ = true; // 标记
            }
            arr.reverse();
            return arr;
        },
        sCardOrder(){
            const oLast = this.round.at(-1);
            if (!oLast) return '';
            const sCard = this.aPokerIntList[oLast.card];
            console.log("sCard", sCard); // 1-13
            return sCard || '';
        },
        // ↓ 操作了5局，如果用户跳过其中2局，返回3
        iRoundNoSkip(){
            const arr = this.round.filter(cur => {
                // 1、2 表示押高、低（意在排除跳过操作）
                return [1,2].includes(cur.ac);
            });
            return arr.length;
        },
        currentCurrency(){
            return useSettingsStore().pickedCurrency || 'btc';
        }
    },
    watch: {
        // ↓ 进入游戏时查验是否有进行中的游戏，有则加载
        oJoinStateStore: { 
            deep: true,
            immediate: true,
            handler(oJoin){
                const length = oJoin?.lastRound?.round?.length;
                if (!length) return;
                // ↑ 没有上一局的信息，就返回
                if (this.sHashLoaded == oJoin.lastRound.hash) return; 
                this.sHashLoaded = oJoin.lastRound.hash;
                // ↓ 将上局的数据显示到页面上
                const oLastRound = deepCopy(oJoin.lastRound);
                this.oGameInfo = oLastRound;
                this.round = oLastRound.round.map(cur => {
                    cur.fromLastRound = true; // 添加标记，这是重载的游戏 
                    return cur;
                });
                this.oJoinStateStore.gameRunning = true; // 设为“游戏进行中” 
                showLastRoundLoadedInfo();
            },
        },
    },
    methods: {
        ...methods,
        ...oCommunicationFn,
    },
    // 👇最后部分是生命周期-----------------------------------
    ...{
        beforeMount() {
            console.log('beforeMount 🧨🎈'); 
            this.oMusic = new MusicControler(oMusicLib);
            useBettingToolkit(this.oForm); // 设定默认下注金额 
        },
        mounted(){
        },
        beforeUnmount(){
            this.oMusic.toDestory(); 
        },
    },
});

</script>



<style lang='scss' scoped src='./style/hiloGame.scss'> </style>

